module.exports = __webpack_public_path__ + "img/8.3e4c7bcf.png";